























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import url from 'url';
import {IInterface, IMultipleOutputs} from '../services/models/Interface';
import {IPlaylist} from '../services/models/Playlist';
import {ISetting} from '../services/models/Setting';

@Component({
    computed: {
    },
    methods: {
    },
})
export default class PlayListEditComponent extends Vue {
    // @ts-ignore
    @Prop() private playlist: IPlaylist;
    @Prop() private interfaces!: IInterface[];
    @Prop() private settings!: ISetting[];

    private ExternalIPKey: string = 'server.external_ip';

    @Emit()
    private urlAdded(newURL: string[]) {
        // dummy
    }

    @Emit()
    private urlRemoved(newURL: string) {
        // dummy
    }

    private mounted() {
        // dummy
    }

    private get Settings(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        if (this.settings) {
            this.settings.forEach((s) => {
                ret[s.key] = s.value;
            });
        }

        return ret;
    }

    private get Interfaces(): { [key: string]: string[] } { // sorts out interfaces can can be used
        const ret: { [key: string]: string[] } = {};
        const sourceNameKey: string = 'bt_name';
        this.interfaces.forEach((int) => {
            // helper function
            const addOutput = (inter: IInterface, externalIP: string, streamid: string | undefined) => {
                if (inter.output && Array.isArray(inter.output) && inter.output.length > 0 && inter.output[0].startsWith('srt://:')) {
                    if (!Array.isArray(ret[inter.name])) {
                        ret[inter.name] = [];
                    }

                    const lurl: any = url.parse(inter.output[0].replace('srt://:', `srt://${externalIP}:`), false, false);
                    if (streamid) {
                        ret[inter.name].push(`${lurl.protocol}//${lurl.hostname}:${lurl.port}?StreamID=${streamid}`);
                    } else {
                        ret[inter.name].push(`${lurl.protocol}//${lurl.hostname}:${lurl.port}`);
                    }
                } else if ((inter.output as IMultipleOutputs).multi) {
                    ret[inter.name] = [];
                    // @ts-ignore
                    inter.output.multi.forEach((output) => {
                        if (output[0].startsWith('srt://:')) {
                            const lurl: any = url.parse(output[0].replace('srt://:', `srt://${externalIP}:`), false, false);

                            if (streamid) {
                                ret[inter.name].push(`${lurl.protocol}//${lurl.hostname}:${lurl.port}?StreamID=${streamid}`);
                            } else {
                                ret[inter.name].push(`${lurl.protocol}//${lurl.hostname}:${lurl.port}`);
                            }
                        }
                    });
                }
            };

            if (JSON.stringify(int.input).indexOf(sourceNameKey) !== -1 && Array.isArray(int.input)) { // input has one or more streamid
                int.input.forEach((input) => {
                    if (input.indexOf(sourceNameKey) !== -1) {
                        const lurl: any = url.parse(input, false, false);
                        const parameters: { [key: string]: string } = {};
                        let params: string[] = [];

                        if (lurl && lurl.query && lurl.query.indexOf('&') !== -1) {
                            params = lurl.query.split('&');
                        } else if (lurl && lurl.query && lurl.query.indexOf('=') !== -1) {
                            params.push(lurl.query);
                        }
                        params.forEach((param) => {
                            if (param.indexOf('=') !== -1) {
                                const values = param.split('=');
                                if (values.length > 1) {
                                    parameters[values[0].toLowerCase()] = values[1];
                                } else {
                                    parameters[values[0].toLowerCase()] = 'true';
                                }
                            } else {
                                parameters[param.toLowerCase()] = 'true';
                            }
                        });

                        addOutput(int, this.Settings[this.ExternalIPKey], parameters[sourceNameKey]);
                    } else {
                        addOutput(int, this.Settings[this.ExternalIPKey], undefined);
                    }
                });
            } else {
                addOutput(int, this.Settings[this.ExternalIPKey], undefined);
            }

        });

        return ret;
    }

    private PlaylistHas(uri: string): boolean {
        return this.playlist && this.playlist.playlist && this.playlist.playlist.vlc && (this.playlist.playlist.vlc.includes(uri) || this.playlist.playlist.vlc.includes(`#${uri}`));
    }

    private UpdatePlaylist(value: boolean, uri: string, name: string): void {
        if (value) {
            this.urlAdded([uri, name]);
        } else {
            this.urlRemoved(uri);
        }
       /* if (this.playlist && this.playlist.playlist) {
            if (!Array.isArray(this.playlist.playlist.vlc)) {
                this.playlist.playlist.vlc = [];
                this.playlist.playlist.playerPro = {
                    id: this.playlist.id,
                    name: this.playlist.name,
                    description: '',
                    icon: '',
                    version: 1,
                    lineups: [],
                };
            }
            this.playlist.playlist.vlc.push(url);
            this.playlist.playlist.playerPro.lineups.push({
                id: '',
                name: name,
                type: 'play',
                description: '',
                url: url,
            });
        }*/
    }
}
